import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";
export const formatAmount = (value, roundUp = false) => {
  if (!value) return "0";
  if (isNaN(Number(value))) return "0";

  let numberValue = Number(value);

  if (roundUp) {
    numberValue = Math.ceil(numberValue); // go to next integer
  }

  return numberValue.toLocaleString("en-US", {
    minimumFractionDigits: roundUp ? 0 : 2,
    maximumFractionDigits: roundUp ? 0 : 2,
  });
};

export const stripDecimals = (val: string | number): string => {
  const num = Number(val);
  if (isNaN(num)) return String(val);
  return Math.floor(num).toString();
};

export const formatValueOrCross = (value: any): string => {
  const invalidValues = ["None", "false", "Not Covered", "-", "", "0.0"];

  //  invalid cases
  if (
    value === null ||
    value === undefined ||
    value === false ||
    value === 0 ||
    invalidValues.includes(value)
  ) {
    return "❌";
  }

  // ✅ number OR numeric string
  const isNumeric =
    (typeof value === "number" && !isNaN(value)) ||
    (typeof value === "string" && /^[+-]?\d+(\.\d+)?$/.test(value.trim()));

  return isNumeric ? stripDecimals(formatAmount(Number(value))) : String(value);
};

export const callUploadFileApi = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await axiosInstance.post(App_Url_New.ApiEndPoint.documentUpload, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};
